import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import createPeerBranchesStore, {  PeersReportsStoreType,PeerBranchType, ReconciliationEvent } from '../../stores/peersReportsStore';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { SupportedDataType } from '../../stores/peersReportsStore/constants';

const PeerBranchesContext = createContext<ReturnType<typeof createPeerBranchesStore> | null>(null);

type PeerBranchesProviderPropsType = {
    peerBranches: PeerBranchType[];
    events: ReconciliationEvent[];
    currentSchemaId: number;
    children: ReactNode;
    currentBranchSupportedData: SupportedDataType[]
};

export function PeerBranchesProvider({ peerBranches, events, currentSchemaId, children, currentBranchSupportedData }: PeerBranchesProviderPropsType) {

    const [peerBranchesStore, setPeerBranchesStore] = useState(() => createPeerBranchesStore({ peerBranches, events, currentSchemaId, currentBranchSupportedData }));

    useEffect(() => {
        setPeerBranchesStore(() => createPeerBranchesStore({ peerBranches, events, currentSchemaId, currentBranchSupportedData }));
    }, [peerBranches, events, currentSchemaId]);

    return <PeerBranchesContext.Provider value={peerBranchesStore}>{children}</PeerBranchesContext.Provider>;
}

export function usePeerBranches<T>(selector: (state: PeersReportsStoreType) => T) {
    const peerBranchesStore = useContext(PeerBranchesContext);
    if (!peerBranchesStore) {
        throw new Error('peerBranchesStore should be used in PeersReportsProvider');
    }
    return useStore(peerBranchesStore, useShallow(selector));
}

export const useGetPeerReportsDiffDetector = (
    reportBusinessKey: string,
) => usePeerBranches((state) => state.actions.getPeerReportDiffDetector(reportBusinessKey));

export const usePeerBranchesActions = () => usePeerBranches(state => state.actions)

export const useReconciliationEvents = () => usePeerBranches(state => state.events)
